import request from "_private/utils/request";
// 查询页面数据
export function FetchCameraManageList(data) {
  return request({
    url: "/base/camera/getPageList",
    method: "post",
    headers: { type: "json" },
    data
  });
}
// 导出
export function exportCamera(data) {
  return request({
    url: "/base/camera/export",
    responseType: "blob",
    headers: { type: "json" },
    method: "post",
    data
  });
}
// 保存摄像头设置
export function saveSettingCameraManage(data) {
  return request({
    url: "/base/camera/updateCameraSetting",
    method: "post",
    headers: { type: "json" },
    data
  });
}
// 检查摄像头是否存在
export function cameraNameIsExist(params) {
  return request({
    url: "/base/camera/checkCameraNameIsExist",
    method: "get",
    headers: { type: "json" },
    params
  });
}
// 查询摄像头下拉树
export function FetchCameraListData(params) {
  return request({
    url: "/monitorCenter/storageVideo/getCameraTree",
    method: "get",
    params
  });
}
// 导入摄像头接口
export function importFile(data) {
  return request({
    url: "/base/camera/import",
    method: "post",
    headers: { type: "json" },
    data
  });
}
